import { Injectable, inject } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { CurrentUserEntityActions } from '@core/account-data';
import { createEffectFactory } from '@core/ngrx-legacy';

import { LanguageConfigHttpService } from './language-config-http.service';
import { LanguageConfigActions } from './language-config.store';
import { LanguageTranslationsActions } from '../language-translations/language-translations.store';

@Injectable({ providedIn: 'root' })
export class LanguageConfigEffects {
  private readonly languageConfigHttpService = inject(LanguageConfigHttpService);
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);

  public effects = createEffectFactory(LanguageConfigActions, this.actions$);

  public fetchLanguageConfig$ = this.effects(LanguageConfigActions.fetch, () =>
    this.languageConfigHttpService.fetchLanguageConfig(),
  );

  public toggleMultilangEnable$ = this.effects(
    LanguageConfigActions.toggleMultilangEnable,
    ({ payload }) =>
      this.languageConfigHttpService.updateLanguageConfig(payload).pipe(
        map(languageItem =>
          LanguageConfigActions.toggleMultilangEnableSuccess({ payload: languageItem }),
        ),
        catchError(error =>
          of(LanguageConfigActions.toggleMultilangEnableFailed({ payload: error })),
        ),
      ),
  );

  public makeLanguageAsDefault$ = this.effects(
    LanguageConfigActions.makeLanguageAsDefault,
    ({ payload }) =>
      this.languageConfigHttpService.updateLanguageConfig(payload).pipe(
        map(languageItem =>
          LanguageConfigActions.makeLanguageAsDefaultSuccess({ payload: languageItem }),
        ),
        catchError(error =>
          of(LanguageConfigActions.makeLanguageAsDefaultFailed({ payload: error })),
        ),
      ),
  );

  public updateCompanyLanguage$ = this.effects(
    LanguageConfigActions.updateCompanyLanguage,
    ({ payload }) =>
      this.languageConfigHttpService.updateLanguageConfig(payload).pipe(
        map(languageItem =>
          LanguageConfigActions.updateCompanyLanguageSuccess({ payload: languageItem }),
        ),
        catchError(error =>
          of(LanguageConfigActions.updateCompanyLanguageFailed({ payload: error })),
        ),
      ),
  );

  constructor() {
    this.actions$
      .pipe(
        ofType(
          LanguageTranslationsActions.updateLanguageTranslationsSuccess,
          LanguageTranslationsActions.createLanguageTranslationsSuccess,
          LanguageTranslationsActions.deleteLanguageSuccess,
          LanguageConfigActions.makeLanguageAsDefaultSuccess,
          LanguageConfigActions.updateCompanyLanguageSuccess,
        ),
      )
      .subscribe(() => {
        this.store.dispatch(LanguageConfigActions.fetch());
      });

    this.actions$.pipe(ofType(LanguageConfigActions.toggleMultilangEnableSuccess)).subscribe(() => {
      this.store.dispatch(CurrentUserEntityActions.fetch());
    });
  }
}
